<div>
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="12" size-xs="12" size-sm="12" size-md="10" size-lg="8" size-xl="6">
        <form [formGroup]="profileForm">
          <ion-card class="user-profile-card">
            <ion-card-header>
              <ion-card-title color="teal" class="section-title">
                {{content?.user?.pages?.profile?.contact?.cardtitle}}</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-list [ngClass]="{
            'invalid-input' : (profileForm.get('address').hasError('required')
            || profileForm.get('state').hasError('required')
            || profileForm.get('city').hasError('required')
            || profileForm.get('postalcode').hasError('required'))
          }">
                <ion-item>
                  <ion-label position="stacked">
                    {{content?.user?.pages?.profile?.contact?.street}}
                    <p slot="end">
                      <ion-note
                        *ngIf="profileForm.get('address').hasError('required') && profileForm.get('address').touched"
                        slot="end" color="danger">
                        {{content?.user?.pages?.profile?.contact?.warning}}</ion-note>
                    </p>
                  </ion-label>
                  <ion-input type="text" formControlName="address"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked">
                    {{content?.user?.pages?.profile?.contact?.city}}
                    <p slot="end">
                      <ion-note *ngIf="profileForm.get('city').hasError('required') && profileForm.get('city').touched"
                        slot="end" color="danger">
                        {{content?.user?.pages?.profile?.contact?.warning}}</ion-note>
                    </p>
                  </ion-label>
                  <ion-input type="text" formControlName="city"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked">
                    {{content?.user?.pages?.profile?.contact?.state}}
                    <p slot="end">
                      <ion-note
                        *ngIf="profileForm.get('state').hasError('required') && profileForm.get('state').touched"
                        slot="end" color="danger">
                        {{content?.user?.pages?.profile?.contact?.warning}}</ion-note>
                    </p>
                  </ion-label>
                  <ion-input type="text" formControlName="state"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked">
                    {{content?.user?.pages?.profile?.contact?.zip}}
                    <p slot="end">
                      <ion-note
                        *ngIf="profileForm.get('postalcode').hasError('required') && profileForm.get('postalcode').touched"
                        slot="end" color="danger">
                        {{content?.user?.pages?.profile?.contact?.warning}}</ion-note>
                    </p>
                  </ion-label>
                  <ion-input type="text" formControlName="postalcode"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked">
                    {{content?.user?.pages?.profile?.contact?.country}}</ion-label>
                  <ion-select cancelText="Dismiss" okText="Ok" formControlName="country">
                    <ion-select-option *ngFor="let country of content?.countries; let i = index; trackBy: trackByIndex;"
                      value="{{country}}">
                      {{country}}</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-list>
            </ion-card-content>
          </ion-card>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>